import { useAuth } from '@cibo/profile'
import { usePrograms } from '@cibo/programs'
import ChevronRight from '@mui/icons-material/ChevronRight'
import { Button, ButtonProps } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { useBuildInfo } from '../../consts/Theme'

type CreateBugReportProps = Pick<ButtonProps, 'color' | 'variant' | 'size'> & {
  errorMessage?: string
}

//@todo - permission for JIRA
export const CreateBugReport = ({ errorMessage, ...buttonProps }: CreateBugReportProps) => {
  const { t } = useTranslation('@cibo/impact/CreateBugReport')
  const auth = useAuth()
  const buildInfo = useBuildInfo()
  const programs = usePrograms()
  const location = useLocation()

  const description = encodeURIComponent(
    t('description', {
      errorMessage: errorMessage || 'No error message provided',
      build: JSON.stringify(buildInfo, null, 2),
      environment: window.location.hostname.endsWith('.com') ? 'prod' : 'dev',
      href: window.location.href,
      location: JSON.stringify(location, null, 2),
      auth: JSON.stringify(auth, null, 2),
      programs: JSON.stringify(
        programs.data?.map(({ programId, program: { content: { fields: { title } } } }) => ({
          programId,
          title,
        })),
        null,
        2
      ),
    })
  )

  return (
    <Button
      endIcon={<ChevronRight />}
      variant="contained"
      color="primary"
      {...buttonProps}
      component="a"
      href={`https://cibotech.atlassian.net/secure/CreateIssueDetails!init.jspa?pid=10041&issuetype=10004&description=${description}&summary=SUMMARIZE%20ISSUE&priority=3&labels=impact`}
      target="_blank"
    >
      Report Bug in JIRA
    </Button>
  )
}
